type AppBootScreenProps = {
  isDark?: boolean
}

export function AppBootScreen(_props: AppBootScreenProps) {
  return (
    <main className="app-boot-screen" aria-label="Application loading state">
      <section className="app-boot-inner">
        <p className="app-boot-kicker">Dihaw.co</p>
        <span className="property-brand-wordmark">Dihaw.co</span>
        <h1 className="app-boot-title">Menyiapkan Dihaw.co...</h1>
        <p className="app-boot-subtitle">
          Cari properti, lihat listing, dan pasang iklan rumah dengan tampilan yang rapi.
        </p>
      </section>
      <div className="app-boot-progress" aria-hidden="true">
        <span className="app-boot-progress-bar" />
      </div>
    </main>
  )
}
